import {
  UPLOAD_POLICIES,
  UPLOAD_PURPOSE_PREFLIGHT_ASSET,
} from "@nexus/contracts";

const MB = 1024 * 1024;

const CONTENT_TYPE_LABEL: Record<string, string> = {
  "image/jpeg": "JPEG",
  "image/png": "PNG",
  "image/webp": "WebP",
  "video/mp4": "MP4",
  "video/quicktime": "MOV",
};

function formatMegabytes(bytes: number): string {
  return `${Math.round(bytes / MB)} MB`;
}

/** User-facing upload limits derived from the Pre-Flight upload policy. */
export function getPreflightUploadConstraints(): {
  formats: string;
  accept: string;
  imageMax: string;
  videoMax: string;
} {
  const policy = UPLOAD_POLICIES[UPLOAD_PURPOSE_PREFLIGHT_ASSET];
  const formats = policy.allowedContentTypes
    .map((contentType) => CONTENT_TYPE_LABEL[contentType] ?? contentType)
    .join(", ");

  return {
    formats,
    accept: policy.allowedContentTypes.join(","),
    imageMax: formatMegabytes(policy.maxSizeBytesByContentType["image/jpeg"] ?? 0),
    videoMax: formatMegabytes(policy.maxSizeBytesByContentType["video/mp4"] ?? 0),
  };
}
